"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDatetime = _interopRequireDefault(require("react-datetime"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
require("moment/locale/es-us");
var _lodash = _interopRequireDefault(require("lodash"));
require("react-datetime/css/react-datetime.css");
var _style = _interopRequireDefault(require("./style.scss"));
var _timePicker = _interopRequireDefault(require("./timePicker"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CLASS_KEY = 'datetime';
var CLASS_NAME = _lodash.default.get(_style.default, CLASS_KEY, CLASS_KEY);
var VIEW_MODE = {
  TIME: 'time'
};
var DEFAULT_TIME = '12:00 AM';
var DownChevron = function DownChevron(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    height: "20",
    width: "20",
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    className: "css-6q0nyr-Svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var renderDay = function renderDay(dayProps, date) {
  var className = dayProps.className;
  if (className.indexOf('rdtOld') > -1) {
    return /*#__PURE__*/_react.default.createElement("td", {
      className: "rdtOld",
      key: date.unix()
    });
  }
  if (className.indexOf('rdtNew') > -1) {
    return null;
  }
  if (className.indexOf('rdtToday') > -1 && className.indexOf('rdtActive') > -1) {
    className = className.replace('rdtActive', '');
  }
  className = className.replace('rdtToday', '');
  return /*#__PURE__*/_react.default.createElement("td", (0, _extends2.default)({}, dayProps, {
    className: className,
    onClick: undefined,
    onKeyPress: undefined,
    key: date.unix()
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "rdtDay"
  }, dayProps), date.format('D')));
};
var Datetime = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Datetime, _Component);
  var _super = _createSuper(Datetime);
  function Datetime(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Datetime);
    _this = _super.call(this, props);
    _this.state = {
      open: false,
      isTimePickerOpening: false
    };
    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.onViewModeChange = _this.onViewModeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickInput = _this.onClickInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderInput = _this.renderInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.container = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  (0, _createClass2.default)(Datetime, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onClick);
      _momentTimezone.default.locale(this.props.locale);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onClick);
    }
  }, {
    key: "onClickInput",
    value: function onClickInput() {
      this.props.onFocus();
      this.setState({
        open: true
      });
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      if (!this.container.current.contains(e.target)) {
        this.handleClickOutside();
      }
    }
  }, {
    key: "onViewModeChange",
    value: function onViewModeChange(viewMode) {
      this.setState({
        isTimePickerOpening: viewMode === VIEW_MODE.TIME
      });
      this.props.onViewModeChange(viewMode);
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "renderInput",
    value: function renderInput(inputProps) {
      var _this2 = this;
      var clear = function clear() {
        _this2.props.onChange(null);
      };
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", inputProps), /*#__PURE__*/_react.default.createElement("span", {
        className: "clear-button",
        hidden: !inputProps.value
      }, /*#__PURE__*/_react.default.createElement(DownChevron, {
        onClick: clear
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        defaultValue = _this$props.defaultValue,
        viewDate = _this$props.viewDate,
        dateFormat = _this$props.dateFormat,
        timeFormat = _this$props.timeFormat,
        input = _this$props.input,
        locale = _this$props.locale,
        utc = _this$props.utc,
        displayTimeZone = _this$props.displayTimeZone,
        onChange = _this$props.onChange,
        onFocus = _this$props.onFocus,
        onBlur = _this$props.onBlur,
        onNavigateBack = _this$props.onNavigateBack,
        onNavigateForward = _this$props.onNavigateForward,
        viewMode = _this$props.viewMode,
        className = _this$props.className,
        inputProps = _this$props.inputProps,
        isValidDate = _this$props.isValidDate,
        renderInput = _this$props.renderInput,
        renderMonth = _this$props.renderMonth,
        renderYear = _this$props.renderYear,
        strictParsing = _this$props.strictParsing,
        closeOnSelect = _this$props.closeOnSelect,
        closeOnTab = _this$props.closeOnTab,
        timeConstraints = _this$props.timeConstraints,
        disableCloseOnClickOutside = _this$props.disableCloseOnClickOutside,
        clearable = _this$props.clearable,
        disabled = _this$props.disabled;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: CLASS_NAME,
        ref: this.container
      }, timeFormat && /*#__PURE__*/_react.default.createElement(_timePicker.default, {
        value: _momentTimezone.default.isMoment(value) ? value : (0, _momentTimezone.default)(DEFAULT_TIME, timeFormat),
        open: this.state.open && this.state.isTimePickerOpening,
        onChange: onChange,
        incrementsMinute: this.props.incrementsMinute
      }), /*#__PURE__*/_react.default.createElement(_reactDatetime.default, {
        value: value,
        defaultValue: defaultValue,
        viewDate: viewDate,
        dateFormat: dateFormat,
        timeFormat: timeFormat,
        input: input,
        open: this.state.open,
        locale: locale,
        utc: utc,
        displayTimeZone: displayTimeZone,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onViewModeChange: this.onViewModeChange,
        onNavigateBack: onNavigateBack,
        onNavigateForward: onNavigateForward,
        viewMode: viewMode,
        className: "".concat(className, " ").concat(timeFormat ? '' : 'no-timepicker'),
        inputProps: _objectSpread(_objectSpread({
          disabled: disabled
        }, inputProps), {}, {
          onClick: this.onClickInput
        }),
        isValidDate: isValidDate,
        renderInput: renderInput || clearable && this.renderInput,
        renderDay: this.props.renderDay || renderDay,
        renderMonth: renderMonth,
        renderYear: renderYear,
        strictParsing: strictParsing,
        closeOnSelect: closeOnSelect,
        closeOnTab: closeOnTab,
        timeConstraints: timeConstraints,
        disableCloseOnClickOutside: disableCloseOnClickOutside
      }), this.props.buttonCalendar && /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        disabled: disabled,
        onClick: this.onClickInput,
        className: "datetime-btn"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-calendar-alt"
      })));
    }
  }]);
  return Datetime;
}(_react.Component);
Datetime.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.shape(Date), _propTypes.default.string]),
  defaultValue: _propTypes.default.shape(Date),
  viewDate: _propTypes.default.shape(Date),
  dateFormat: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  timeFormat: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  input: _propTypes.default.bool,
  locale: _propTypes.default.string,
  utc: _propTypes.default.bool,
  displayTimeZone: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onViewModeChange: _propTypes.default.func,
  onNavigateBack: _propTypes.default.func,
  onNavigateForward: _propTypes.default.func,
  viewMode: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  className: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  inputProps: _propTypes.default.shape({}),
  isValidDate: _propTypes.default.func,
  renderInput: _propTypes.default.func,
  renderDay: _propTypes.default.func,
  renderMonth: _propTypes.default.func,
  renderYear: _propTypes.default.func,
  strictParsing: _propTypes.default.bool,
  closeOnSelect: _propTypes.default.bool,
  closeOnTab: _propTypes.default.bool,
  timeConstraints: _propTypes.default.shape({}),
  disableCloseOnClickOutside: _propTypes.default.bool,
  buttonCalendar: _propTypes.default.bool,
  incrementsMinute: _propTypes.default.number,
  clearable: _propTypes.default.bool,
  disabled: _propTypes.default.bool
};
Datetime.defaultProps = {
  value: undefined,
  defaultValue: undefined,
  viewDate: new Date(),
  dateFormat: true,
  timeFormat: true,
  input: true,
  locale: 'en-us',
  utc: false,
  displayTimeZone: null,
  onChange: _lodash.default.noop,
  onFocus: _lodash.default.noop,
  onBlur: _lodash.default.noop,
  onViewModeChange: _lodash.default.noop,
  onNavigateBack: _lodash.default.noop,
  onNavigateForward: _lodash.default.noop,
  viewMode: 'days',
  className: '',
  inputProps: undefined,
  isValidDate: function isValidDate() {
    return true;
  },
  renderInput: undefined,
  renderDay: undefined,
  renderMonth: undefined,
  renderYear: undefined,
  strictParsing: true,
  closeOnSelect: false,
  closeOnTab: true,
  timeConstraints: undefined,
  disableCloseOnClickOutside: true,
  buttonCalendar: true,
  incrementsMinute: 1,
  clearable: false,
  disabled: false
};
var _default = Datetime;
exports.default = _default;